module.exports = __webpack_public_path__ + "img/gamesdk6.ef3e817.png";